import { Box } from "@mui/material";
import React from "react";
import classes from './ArticleCardDetails.module.scss';
import { ArticleCardDetailsProps } from "../../interfaces/props/ArticleCardDetailsProps";
import InformationSection from "../Information-section/InformationSection";

const ArticleCardDetails = React.memo(({ facts, tipsAndPredictions, tvChannels }: ArticleCardDetailsProps) => {
  return <Box className={`${classes.box} d-flex flex-row flex-wrap justify-content-between `}>
    <Box className={`${classes.detailsBox} p-3`}>
      <InformationSection title='Facts' content={facts} biggerFont={false} />
    </Box>
    <Box className={`${classes.detailsBox} p-3`}>
      <InformationSection title='Tips And Predictions' content={tipsAndPredictions} biggerFont={false} />
    </Box>
    <Box className={`${classes.detailsBox} p-3`}>
      <InformationSection title='Tv Channels' content={tvChannels} biggerFont={false} />
    </Box>
  </Box>
});

export default ArticleCardDetails;
